import { initializeApp } from "firebase/app";
import { appConstants } from "./app-constants";

// Your web app's Firebase configuration
const _firebaseConfig = JSON.parse(appConstants.firebaseConfig || "{}");

/* const _firebaseConfig = {
  apiKey: "AIzaSyChvCevwZlIc2vb3Wbr7XkH61fGdiSZo54",
  authDomain: "my-tax-club-dev.firebaseapp.com",
  projectId: "my-tax-club-dev",
  storageBucket: "my-tax-club-dev.appspot.com",
  messagingSenderId: "683301663449",
  appId: "1:683301663449:web:0638baeb3dd806c54584c8",
  measurementId: "G-MESRQXHREN"
}; */

// Initialize Firebase
const firebaseConfig = initializeApp(_firebaseConfig);
export default firebaseConfig;
